import React, { useState } from 'react';
import RecoverPassForm from '../components/RecoverPassForm/RecoverPassForm';
import RecoverSucceeded from '../components/RecoverSucceeded/RecoverSucceeded';
import DefaultLayout from '../layout/DefaultLayout';

const RecoverPass: React.FC = () => {
    const [submitSucceeded, setSubmitSucceeded] = useState<boolean>(false);
    const handleSubmitSucceeded = () => setSubmitSucceeded(true);
    return (
        <DefaultLayout>
            {submitSucceeded ? <RecoverSucceeded /> : <RecoverPassForm handleSuccess={handleSubmitSucceeded} />}
        </DefaultLayout>
    );
};

export default RecoverPass;
